import { AdminInquiryConst } from "../Constants/AdminInquiryConstants";

const initialState = {
  loader: false,
  inquiries: [],
  inquiriesError: null,
  messages: [],
  messagesError: null,
  actionSuccess: null,
  actionError: null,
};

const adminInquiryReducer = (state = initialState, action) => {
  switch (action.type) {
    // ── Fetch my inquiries ──────────────────────────────────────────────────
    case AdminInquiryConst.FETCH_MY_INQUIRIES_REQUEST:
      return { ...state, loader: true, inquiriesError: null };
    case AdminInquiryConst.FETCH_MY_INQUIRIES_SUCCESS:
      return { ...state, loader: false, inquiries: action.result.data ?? [] };
    case AdminInquiryConst.FETCH_MY_INQUIRIES_FAIL:
      return { ...state, loader: false, inquiriesError: action.result };

    // ── Create inquiry ──────────────────────────────────────────────────────
    case AdminInquiryConst.CREATE_INQUIRY_REQUEST:
      return { ...state, loader: true, actionSuccess: null, actionError: null };
    case AdminInquiryConst.CREATE_INQUIRY_SUCCESS:
      return {
        ...state,
        loader: false,
        actionSuccess: action.result,
        inquiries: [action.result.data, ...state.inquiries],
      };
    case AdminInquiryConst.CREATE_INQUIRY_FAIL:
      return { ...state, loader: false, actionError: action.result };

    // ── Fetch messages ──────────────────────────────────────────────────────
    case AdminInquiryConst.FETCH_MESSAGES_REQUEST:
      return { ...state, loader: true, messagesError: null };
    case AdminInquiryConst.FETCH_MESSAGES_SUCCESS:
      return { ...state, loader: false, messages: action.result.data ?? [] };
    case AdminInquiryConst.FETCH_MESSAGES_FAIL:
      return { ...state, loader: false, messagesError: action.result };

    // ── Send message ────────────────────────────────────────────────────────
    case AdminInquiryConst.SEND_MESSAGE_REQUEST:
      return { ...state, actionSuccess: null, actionError: null };
    case AdminInquiryConst.SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        messages: [...state.messages, action.result.data],
        actionSuccess: action.result,
      };
    case AdminInquiryConst.SEND_MESSAGE_FAIL:
      return { ...state, actionError: action.result };

    case AdminInquiryConst.CLEAR_ACTION:
      return { ...state, actionSuccess: null, actionError: null };

    default:
      return state;
  }
};

export default adminInquiryReducer;
